export enum ReportFieldType {
    Date = 'date',
    String = 'string',
    Number = 'number',
    Decimal = 'decimal',
    Currency = 'currency',
    Boolean = 'boolean',

    RichText = 'richText',

    Customer = 'customer',
    Uom = 'uom',
    Priority = 'priority',
    Company = 'company',
    Pricebook = 'pricebook',
    JobLabel = 'jobLabel',
    JobType = 'jobType',
    FieldSupervisor = 'fieldSupervisor',
    Owner = 'owner',
    CustomerPO = 'customerPO',
    CustomerSupervisor = 'customerSupervisor',
    Zone = 'zone',
    Contractor = 'contractor',
    WorkCategory = 'workCategory',
    WOLabel = 'woLabel',
    WOResource = 'woResource',
    WOStatus = 'woStatus',
    Category = 'category',

    //Status not fully supported yet due to being a string in db and not an actual object
    Status = 'status',

    /** Mostly use for filter, and simple display (by **name** property) */
    EntityStatus = 'entityStatus',

    Suburb = 'suburb',
    State = 'state',
    Postcode = 'postcode',
    Address = 'address',

    Link = 'link',

    Tag = 'tag',
}